import { createJSONStorage, persist } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

const addKeyword = (searchKeywords, keyword) => {
  if (searchKeywords.includes(keyword)) return searchKeywords;

  searchKeywords.unshift(keyword);
  if (searchKeywords.length > 6) searchKeywords.pop();

  return searchKeywords;
};

const useStore = createWithEqualityFn(
  persist(
    (set, get) => ({
      data: {
        searchKeywords: [],
      },
      actions: {
        getPreviousSearches: () => get().data.searchKeywords,
        addSearchKeyword: (keyword) => {
          set((s) => ({
            data: {
              searchKeywords: addKeyword(s.data.searchKeywords, keyword),
            },
          }));
        },
      },
    }),
    {
      name: "user-previous-searches",
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used,
      partialize: ({ data }) => ({ data }),
    }
  )
);

export default useStore;
